import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Inbox, Truck, Navigation, FileText, Coffee } from "lucide-react";
import { BigButton } from "@/components/BigButton";
import { t } from "@/i18n";

const STEPS = [
  { icon: Inbox, title: "1. Ricevi l'ordine", text: "Gli ordini del vettore compaiono in VIAGGI. Premi ACCETTA VIAGGIO per confermarlo subito." },
  { icon: Truck, title: "2. Aggiorna lo stato", text: "Usa i 4 tasti grandi: Carico in corso, Partito, In pausa, Arrivato. Il vettore riceve ogni cambio." },
  { icon: Navigation, title: "3. Naviga", text: "Premi NAVIGATORE: il percorso si ricalcola da solo se arriva un avviso ANAS o ANSA sulla tua strada." },
  { icon: FileText, title: "4. Documenti", text: "DDT e CMR sono in DOCUMENTI, pronti da mostrare o firmare." },
  { icon: Coffee, title: "5. Pausa sicura", text: "In alto vedi le ore di guida rimaste. Quando servono, premi PAUSA per andare all'area di servizio più vicina." },
];

export const Onboarding = ({ open, onClose }) => {
  const [i, setI] = useState(0);
  const s = STEPS[i];
  const close = () => {
    setI(0);
    onClose();
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-w-xl bg-[#0b0f17] border-[#243047] text-white" data-testid="onboarding-dialog">
        <DialogTitle className="nv-eyebrow">{t("Guida rapida")} · {i + 1}/{STEPS.length}</DialogTitle>
        <div className="py-4">
          <div className="h-20 w-20 rounded-2xl grid place-items-center bg-[#4accff]/15 text-[#4accff] mb-5"><s.icon className="h-10 w-10" /></div>
          <h3 className="font-display text-3xl font-extrabold uppercase">{t(s.title)}</h3>
          <p className="text-lg text-slate-300 mt-2">{t(s.text)}</p>
        </div>
        <div className="flex gap-2 mb-2">{STEPS.map((_, k) => <span key={k} className="h-2 flex-1 rounded-full" style={{ background: k <= i ? "#4accff" : "var(--nv-border)" }} />)}</div>
        <div className="grid grid-cols-2 gap-3">
          <BigButton testId="onboarding-skip-btn" variant="outline" color="#ffffff" label={t("Salta")} onClick={close} />
          <BigButton testId="onboarding-next-btn" color="#ef0298" label={t(i === STEPS.length - 1 ? "Inizia" : "Avanti")} onClick={() => (i === STEPS.length - 1 ? close() : setI(i + 1))} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
